import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function FeedCTA() {
  const { t } = useTranslation()

  return (
    <Link
      to="/signup"
      style={{
        display: 'block',
        width: '100%',
        textAlign: 'start',
        cursor: 'pointer',
        textDecoration: 'none',
        border: '1px solid color-mix(in srgb, var(--brand) 26%, var(--border))',
        background: 'color-mix(in srgb, var(--brand) 8%, var(--surface))',
        borderRadius: 'var(--radius-md)',
        padding: '14px 16px',
        boxSizing: 'border-box',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div style={{ flex: 1 }}>
          <div
            style={{
              fontFamily: 'var(--font-sans)',
              fontWeight: 700,
              fontSize: 'var(--fs-body)',
              color: 'var(--text-strong)',
            }}
          >
            {t('welcome.join_title')}
          </div>
          <div
            style={{
              marginTop: 2,
              fontSize: 'var(--fs-sm)',
              color: 'var(--text-muted)',
              lineHeight: 'var(--lh-normal)',
            }}
          >
            {t('welcome.join_sub')}
          </div>
        </div>

        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            flexShrink: 0,
            background: 'var(--brand)',
            color: 'var(--on-brand)',
            borderRadius: 'var(--radius-pill)',
            padding: '8px 14px',
            fontFamily: 'var(--font-sans)',
            fontWeight: 600,
            fontSize: 'var(--fs-sm)',
          }}
        >
          {t('welcome.signup')}
          <ChevronRight size={16} />
        </span>
      </div>
    </Link>
  )
}
